import { Link } from 'react-router-dom';
import { newMovies } from '@/mocks/movies';

export default function LatestMovies() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
              最新上映
            </h2>
            <p className="text-sm text-foreground-500 mt-1">院线同步更新，最新影片一网打尽</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {newMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/movie/${movie.id}`}
              className="group flex flex-col cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  title={`${movie.title} - 星空影院最新上映`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-background-50 text-xl"></i>
                  </div>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-semibold whitespace-nowrap">
                    NEW
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <div className="flex items-center gap-0.5 px-2 py-0.5 rounded-full bg-background-50/80 text-foreground-950 text-[10px] font-semibold whitespace-nowrap">
                    <i className="ri-star-fill text-primary-500 text-[8px]"></i>
                    {movie.rating}
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors truncate">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{movie.year} / {movie.region}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}